module.exports = __webpack_public_path__ + "static/media/folder_exe.e5028c51.ico";